// TODO:non-essential: REFACTOR THIS CODE

///////////////////////////////////////////////////////////////////
///////////////// NAVBAR MOBILE SCRIPT ///////////////////////////
//////////////// nav-mobile-menu script /////////////////////////
////////////////////////////////////////////////////////////////

// TODO:non-essential: decide whether to keep it in the nav-mobile-navigation.liquid put its script

//////////////////////////////////////////////////////////////////////////
///////////////// NAVBAR DESKTOP (MEGA) MENU SCRIPT /////////////////////
//////////////// nav-desktop-menu script ///////////////////////////////
///////////////////////////////////////////////////////////////////////

document.addEventListener("DOMContentLoaded", function () {
  const navContainer = document.querySelector(".nav--container");
  const shopLogo = document.getElementById("shopLogo");
  const navMenus = document.querySelectorAll(".mega-menu-content");
  const navMenuLinks = document.querySelectorAll(".nav--menu-link");
  const menuLinksWithSubmenu = document.querySelectorAll(
    ".nav--menu-link.has-submenu"
  );
  let tabPressed = false;

  // Initialize the nav menus as hidden
  navMenus.forEach((menu) => {
    menu.setAttribute("aria-hidden", "true");
  });

  // Detect when the Tab key is pressed
  document.addEventListener("keydown", (e) => {
    if (e.key === "Tab") {
      tabPressed = true;
      styleNavContainerOnFocus();
    }
  });

  // Detect when focus is lost from nav--container
  document.addEventListener("focusin", (e) => {
    if (!navContainer.contains(e.target)) {
      resetNavContainerStyle();
      tabPressed = false;
    }
  });

  // Functions for focusable elements
  const findFirstFocusableElement = (menu) => {
    return menu.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
  };

  const getFocusableElements = (menu) => {
    return menu.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
  };

  menuLinksWithSubmenu.forEach((menuLink) => {
    const item = menuLink.closest(".nav--menu-item");
    const menuId = menuLink.getAttribute("aria-controls");
    const dropdownMenu = document.getElementById(menuId);
    let timeoutId;

    // Open the dropdown menu
    const openDropdown = () => {
      clearTimeout(timeoutId);
      dropdownMenu.classList.add("is-visible");
      menuLink.setAttribute("aria-expanded", "true");
      dropdownMenu.setAttribute("aria-hidden", "false");
      item.setAttribute("data-hover", "true");
    };

    // Close the dropdown menu with a delay
    const closeDropdownDelayed = () => {
      timeoutId = setTimeout(() => {
        dropdownMenu.classList.remove("is-visible");
        dropdownMenu.setAttribute("aria-hidden", "true");
        menuLink.setAttribute("aria-expanded", "false");
        item.removeAttribute("data-hover");
      }, 100);
    };

    // Event listeners for mouse interaction
    item.addEventListener("mouseenter", openDropdown);
    item.addEventListener("mouseleave", closeDropdownDelayed);

    dropdownMenu.addEventListener("mouseenter", openDropdown);
    dropdownMenu.addEventListener("mouseleave", closeDropdownDelayed);

    // Keyboard navigation within the dropdown menu
    const handleDropdownKeydown = (e) => {
      if (e.key === "Tab") {
        const focusableElements = getFocusableElements(dropdownMenu);

        if (focusableElements.length > 0) {
          const firstElement = focusableElements[0];
          const lastElement = focusableElements[focusableElements.length - 1];

          if (!e.shiftKey && document.activeElement === lastElement) {
            e.preventDefault();
            const nextNavItem = item.nextElementSibling;
            if (nextNavItem) {
              nextNavItem.querySelector(".nav--menu-link").focus();
            } else {
              dropdownMenu.parentElement.nextElementSibling?.focus();
            }
            closeDropdownDelayed();
          } else if (e.shiftKey && document.activeElement === firstElement) {
            e.preventDefault();
            menuLink.focus();
          }
        }
      } else if (e.key === "Escape") {
        e.preventDefault();
        closeDropdownDelayed();
        menuLink.focus();
      }
    };

    dropdownMenu.addEventListener("keydown", handleDropdownKeydown);

    // Add focusout event to dropdownMenu
    dropdownMenu.addEventListener("focusout", (e) => {
      if (
        !dropdownMenu.contains(e.relatedTarget) &&
        e.relatedTarget !== menuLink
      ) {
        closeDropdownDelayed();
      }
    });

    // Keyboard interaction for menu links
    const handleMenuLinkKeydown = (e) => {
      if (e.key === "ArrowDown" || e.key === "Down") {
        e.preventDefault();
        openDropdown();
        const firstFocusableElement = findFirstFocusableElement(dropdownMenu);
        if (firstFocusableElement) firstFocusableElement.focus();
      } else if (e.key === "Tab" && !e.shiftKey) {
        if (dropdownMenu.classList.contains("is-visible")) {
          const firstFocusableElement = findFirstFocusableElement(dropdownMenu);
          if (firstFocusableElement) {
            e.preventDefault();
            firstFocusableElement.focus();
          }
        }
      }
    };

    menuLink.addEventListener("keydown", handleMenuLinkKeydown);

    // Adjusted blur event for menuLink
    menuLink.addEventListener("blur", (e) => {
      if (dropdownMenu.contains(e.relatedTarget)) {
        return;
      } else {
        closeDropdownDelayed();
      }
    });
  });

  // Function to apply styles to nav--container and its elements when focused using Tab
  const styleNavContainerOnFocus = () => {
    if (!tabPressed) return;
    navContainer.classList.add("nav--focused");
  };

  // Function to remove styles from nav--container and its elements when focus is lost
  const resetNavContainerStyle = () => {
    navContainer.classList.remove("nav--focused");
  };

  // Add focusout event listener to nav--container to reset styles
  if (navContainer) {
    navContainer.addEventListener("focusout", (e) => {
      if (!navContainer.contains(e.relatedTarget)) {
        resetNavContainerStyle();
      }
    });
  }
});

///////////////////////////////////////////////////////////////////
///////////////// NAVBAR SCROLLING SCRIPT ////////////////////////
//////////////// navbar-scrolling script ////////////////////////
////////////////////////////////////////////////////////////////

document.addEventListener("DOMContentLoaded", function () {
  const navContainer = document.querySelector(".nav--container");
  let lastScrollY = window.scrollY;
  let ticking = false;

  function onScroll() {
    const currentScrollY = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(function () {
        handleScroll(currentScrollY);
        ticking = false;
      });

      ticking = true;
    }
  }

  function handleScroll(currentScrollY) {
    const adjustedNavHeight = navContainer.offsetHeight;
    const isMobile = window.innerWidth <= 800;
    const mobileThreshold = isMobile
      ? adjustedNavHeight * 0.2
      : adjustedNavHeight;

    if (currentScrollY > lastScrollY && currentScrollY > adjustedNavHeight) {
      // User is scrolling down and navbar is out of sight
      navContainer.classList.remove("navbar-scrolling");
    } else if (
      currentScrollY < lastScrollY &&
      currentScrollY > adjustedNavHeight
    ) {
      // User is scrolling up
      navContainer.classList.add("navbar-scrolling");
    }

    if (currentScrollY <= mobileThreshold) {
      // User is at the top of the page or close to it (remove navbar-scrolling earlier on mobile)
      navContainer.classList.remove("navbar-scrolling");
    }

    lastScrollY = currentScrollY;
  }

  window.addEventListener("scroll", onScroll, { passive: true });
});

///////////////////////////////////////////////////////////////////
///////////////// NAVBAR SEARCHBAR SCRIPT ////////////////////////
//////////////// nav-searchbar script ///////////////////////////
////////////////////////////////////////////////////////////////

// TODO:non-essential: sort of already done but refactor if you can

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// code below searches by product tags but might fail one day due to requests overload, also shopify allows 250 product fetches //
// additional comment: it's unlikely this code will find by tag when a tag's name is present in any product's title or vendor ///
////////// also likely fails to translate, if needed, revert back to code way below to use pre-title (vendor) instead of tags //
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

document.addEventListener("DOMContentLoaded", function () {
  const elements = {
    searchBarButton: document.getElementById("searchBarButton"),
    searchModal: document.getElementById("searchModal"),
    modalContent: document.querySelector(".nav-searchbar-modal-content"),
    searchResults: document.getElementById("searchResults"),
    articleResults: document.getElementById("articleResults"),
    collectionResults: document.getElementById("collectionResults"),
    defaultMessage: document.getElementById("defaultSearchDisplay"),
    loadingIndicator: document.getElementById("loadingIndicator"),
    noResultsMessage: document.getElementById("noResultsMessage"),
    closeSearchBarButton: document.getElementById("closeSearchBarButton"),
    searchBarInput: document.querySelector(".nav-searchbar-input"),
    showProductsButton: document.getElementById("showProductsButton"),
    showArticlesButton: document.getElementById("showArticlesButton"),
    showCollectionsButton: document.getElementById("showCollectionsButton"),
    searchTypeButtons: document.getElementById("searchTypeButtons"),
    searchTitle: document.getElementById("searchTitle"),
    searchTitleText: document.getElementById("searchTitleText"),
  };

  let debounceTimeout;
  let focusableElementsOutsideModal = [];

  // Function to trap focus within the modal
  const trapFocus = (element) => {
    const focusableElements = element.querySelectorAll(
      'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
    );
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement =
      focusableElements[focusableElements.length - 1];

    element.addEventListener("keydown", (e) => {
      if (e.key === "Tab") {
        if (e.shiftKey) {
          // Shift + Tab: Move focus backward
          if (document.activeElement === firstFocusableElement) {
            e.preventDefault();
            lastFocusableElement.focus(); // Loop back to the last element
          }
        } else {
          // Tab: Move focus forward
          if (document.activeElement === lastFocusableElement) {
            e.preventDefault();
            firstFocusableElement.focus(); // Loop back to the first element
          }
        }
      }
    });
  };

  // Function to disable focus on elements outside the modal
  const disableFocusOutsideModal = () => {
    focusableElementsOutsideModal = Array.from(
      document.querySelectorAll(
        'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => !elements.searchModal.contains(el));

    focusableElementsOutsideModal.forEach((el) => {
      el.setAttribute("data-tabindex", el.getAttribute("tabindex") || "0");
      el.setAttribute("tabindex", "-1");
    });
  };

  // Function to enable focus back on elements outside the modal
  const enableFocusOutsideModal = () => {
    focusableElementsOutsideModal.forEach((el) => {
      const originalTabindex = el.getAttribute("data-tabindex");
      if (originalTabindex === "0") {
        el.removeAttribute("tabindex");
      } else {
        el.setAttribute("tabindex", originalTabindex);
      }
      el.removeAttribute("data-tabindex");
    });
  };

  function toggleVisibility(element, hide, displayType = "block") {
    element.style.display = hide ? "none" : displayType;
    element.setAttribute("aria-hidden", hide ? "true" : "false");
  }

  function showModal() {
    toggleVisibility(elements.searchModal, false);
    elements.searchBarButton.setAttribute("aria-expanded", "true");
    disableBodyScroll();
    disableFocusOutsideModal(); // Disable focus on elements outside the modal
    setTimeout(() => {
      elements.modalContent.style.right = "0";
    }, 10);

    if (window.innerWidth >= 800) {
      elements.searchBarInput.focus();
    }

    // Use requestAnimationFrame for focus trapping after content is rendered
    requestAnimationFrame(() => {
      trapFocus(elements.searchModal); // Trap focus after rendering the frame
    });
  }

  function hideModal() {
    elements.modalContent.style.right = "-100%";
    enableBodyScroll();
    enableFocusOutsideModal(); // Enable focus back on elements outside the modal
    setTimeout(() => {
      toggleVisibility(elements.searchModal, true);
      elements.searchBarButton.setAttribute("aria-expanded", "false");
      elements.searchBarButton.focus();
    }, 400);
    resetState();
  }

  function disableBodyScroll() {
    document.body.style.overflow = "hidden"; // Disable body scroll
    elements.modalContent.style.overflowY = "auto"; // Ensure the modal itself can scroll
  }

  function enableBodyScroll() {
    document.body.style.overflow = ""; // Re-enable body scroll
    elements.modalContent.style.overflowY = ""; // Reset overflow on the modal
  }

  function resetState() {
    elements.searchBarInput.value = "";
    resetTabs();
    showDefaultMessage();
    toggleVisibility(elements.searchTypeButtons, true);
    toggleVisibility(elements.searchTitle, true);
  }

  function resetTabs() {
    elements.showProductsButton.classList.add("active");
    elements.showArticlesButton.classList.remove("active");
    elements.showCollectionsButton.classList.remove("active");
  }

  function formatPrice(price) {
    return `€ ${parseInt(price, 10).toLocaleString("de-DE")}`;
  }

  function createElement(templateId, data, mappings) {
    const template = document
      .getElementById(templateId)
      .content.cloneNode(true);

    Object.entries(mappings).forEach(([selector, mapFunc]) => {
      const element = template.querySelector(selector);
      if (element) {
        if (typeof mapFunc === "function") {
          mapFunc(element, data);
        } else {
          element.textContent = data[mapFunc];
        }
      }
    });

    return template;
  }

  function damerauLevenshteinDistance(a, b) {
    const lenA = a.length;
    const lenB = b.length;
    const dp = Array.from({ length: lenA + 1 }, () => Array(lenB + 1).fill(0));

    for (let i = 0; i <= lenA; i++) dp[i][0] = i;
    for (let j = 0; j <= lenB; j++) dp[0][j] = j;

    for (let i = 1; i <= lenA; i++) {
      for (let j = 1; j <= lenB; j++) {
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        dp[i][j] = Math.min(
          dp[i - 1][j] + 1,
          dp[i][j - 1] + 1,
          dp[i - 1][j - 1] + cost
        );
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
          dp[i][j] = Math.min(dp[i][j], dp[i - 2][j - 2] + cost);
        }
      }
    }
    return dp[lenA][lenB];
  }

  function isFuzzyMatch(query, target) {
    const lowerQuery = query.toLowerCase();
    const lowerTarget = target.toLowerCase();
    const maxDistance = lowerQuery.length <= 5 ? 1 : 2;

    if (lowerTarget.includes(lowerQuery)) return true;

    for (let i = 0; i <= lowerTarget.length - lowerQuery.length; i++) {
      const substring = lowerTarget.substring(i, i + lowerQuery.length);
      if (damerauLevenshteinDistance(lowerQuery, substring) <= maxDistance) {
        return true;
      }
    }
    return false;
  }

  function matchInFields(query, item) {
    return [item.title, item.vendor || ""].some((field) =>
      isFuzzyMatch(query, field)
    );
  }

  async function fetchData(query, type) {
    const broadQuery = query.length > 2 ? query.slice(0, 2) : query;
    const response = await fetch(
      `/search/suggest.json?q=${encodeURIComponent(
        broadQuery
      )}&resources[type]=${type}`
    );
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return response.json();
  }

  function processResults(items, templateId, resultsContainer, mappings) {
    resultsContainer.innerHTML = "";
    const fuzzyResults = items
      .filter((item) => matchInFields(elements.searchBarInput.value, item))
      .map((item) => ({
        item,
        distance: damerauLevenshteinDistance(
          elements.searchBarInput.value,
          item.title
        ),
      }))
      .sort((a, b) => a.distance - b.distance)
      .map((result) => result.item);

    if (fuzzyResults.length > 0) {
      fuzzyResults.forEach((item) => {
        const element = createElement(templateId, item, mappings);
        resultsContainer.appendChild(element);
      });
    }
  }

  async function fetchSearchResults(query) {
    try {
      const data = await fetchData(query, "product");
      processResults(
        data.resources.results.products,
        "productSearchResultTemplate",
        elements.searchResults,
        {
          a: (el, product) => (el.href = product.url),
          img: (el, product) => {
            el.src = product.image ? product.image : "default-image.jpg";
            el.alt = product.title;
          },
          h5: "title",
          ".product-vendor": "vendor", // Vendor name mapping
          ".product-price": (el, product) =>
            (el.textContent = formatPrice(product.price)),
        }
      );
    } catch (error) {
      handleError(error);
    }
  }

  async function fetchArticleResults(query) {
    try {
      const data = await fetchData(query, "article");
      processResults(
        data.resources.results.articles,
        "articleSearchResultTemplate",
        elements.articleResults,
        {
          a: (el, article) => (el.href = article.url),
          img: (el, article) => {
            el.src = article.image;
            el.alt = article.title;
          },
          h5: "title",
          ".article-body": (el, article) =>
            (el.textContent = article.body.substring(0, 100) + "..."),
        }
      );
    } catch (error) {
      handleError(error);
    }
  }

  async function fetchCollectionResults(query) {
    try {
      const data = await fetchData(query, "collection");
      processResults(
        data.resources.results.collections,
        "collectionSearchResultTemplate",
        elements.collectionResults,
        {
          a: (el, collection) => (el.href = collection.url),
          h5: "title",
        }
      );
    } catch (error) {
      handleError(error);
    }
  }

  async function handleNoResultsFallback(query) {
    try {
      console.log("Triggering fallback search to fetch all products.");

      const response = await fetch("/collections/all/products.json");
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();

      const matchingProducts = data.products.filter((product) =>
        product.tags.some((tag) => isFuzzyMatch(query, tag))
      );

      const formattedProducts = matchingProducts.map((product) => ({
        title: product.title,
        url: `/products/${product.handle}`,
        image:
          product.images.length > 0
            ? product.images[0].src
            : "default-image.jpg",
        price: product.variants.length > 0 ? product.variants[0].price : "N/A",
        vendor: product.vendor, // Include vendor in fallback search
      }));

      if (formattedProducts.length > 0) {
        formattedProducts.forEach((product) => {
          const element = createElement(
            "productSearchResultTemplate",
            product,
            {
              a: (el, product) => (el.href = product.url),
              img: (el, product) => {
                el.src = product.image;
                el.alt = product.title;
              },
              h5: (el, product) => (el.textContent = product.title),
              ".product-vendor": (el, product) =>
                (el.textContent = product.vendor),
              ".product-price": (el, product) =>
                (el.textContent = formatPrice(product.price)),
            }
          );
          elements.searchResults.appendChild(element);
        });

        // Ensure the searchTitle is displayed when results are found
        elements.searchTitleText.innerText =
          elements.searchTitleText.getAttribute("data-products-title");
        toggleVisibility(elements.searchTitle, false);
        toggleVisibility(elements.searchTypeButtons, true);

        showSearchResults();
      } else {
        showNoResultsIfNone();
      }
    } catch (error) {
      console.error("Error in handleNoResultsFallback:", error);
      handleError(error);
    }
  }

  function showNoResultsIfNone() {
    const hasProducts = elements.searchResults.innerHTML.trim().length > 0;
    const hasArticles = elements.articleResults.innerHTML.trim().length > 0;
    const hasCollections =
      elements.collectionResults.innerHTML.trim().length > 0;

    if (!hasProducts && !hasArticles && !hasCollections) {
      showNoResultsMessage();
      toggleVisibility(elements.searchTitle, true); // Hide searchTitle when no results
    }
  }

  async function handleSearchInput() {
    const query = elements.searchBarInput.value.trim();
    if (!query) {
      clearTimeout(debounceTimeout);
      resetState();
      return;
    }

    showLoadingIndicator();
    clearTimeout(debounceTimeout);

    debounceTimeout = setTimeout(async () => {
      try {
        await Promise.all([
          fetchSearchResults(query),
          fetchArticleResults(query),
          fetchCollectionResults(query),
        ]);

        const hasProducts = elements.searchResults.innerHTML.trim().length > 0;
        const hasArticles = elements.articleResults.innerHTML.trim().length > 0;
        const hasCollections =
          elements.collectionResults.innerHTML.trim().length > 0;

        if (hasProducts + hasArticles + hasCollections > 1) {
          toggleVisibility(elements.searchTypeButtons, false, "flex");
          toggleVisibility(elements.searchTitle, true);
          resetTabs();
          toggleVisibility(elements.noResultsMessage, true);

          elements.showProductsButton.style.display = hasProducts
            ? "inline-block"
            : "none";
          elements.showArticlesButton.style.display = hasArticles
            ? "inline-block"
            : "none";
          elements.showCollectionsButton.style.display = hasCollections
            ? "inline-block"
            : "none";

          if (hasProducts) {
            elements.showProductsButton.classList.add("active");
            showSearchResults();
          } else if (hasArticles) {
            elements.showArticlesButton.classList.add("active");
            showArticleResults();
          } else if (hasCollections) {
            elements.showCollectionsButton.classList.add("active");
            showCollectionResults();
          }
        } else if (hasProducts || hasArticles || hasCollections) {
          toggleVisibility(elements.searchTypeButtons, true);
          toggleVisibility(elements.searchTitle, false);
          if (hasProducts) {
            elements.searchTitleText.innerText =
              elements.searchTitleText.getAttribute("data-products-title");
            showSearchResults();
          } else if (hasArticles) {
            elements.searchTitleText.innerText =
              elements.searchTitleText.getAttribute("data-articles-title");
            showArticleResults();
          } else if (hasCollections) {
            elements.searchTitleText.innerText =
              elements.searchTitleText.getAttribute("data-collections-title");
            showCollectionResults();
          }
        } else {
          await handleNoResultsFallback(query);
        }
      } catch (error) {
        handleError(error);
      }
    }, 300);
  }

  function handleError(error) {
    console.error("Error fetching results:", error);
    toggleVisibility(elements.noResultsMessage, false);
    toggleVisibility(elements.defaultMessage, true);
    toggleVisibility(elements.loadingIndicator, true);
  }

  function showDefaultMessage() {
    toggleVisibility(elements.defaultMessage, false);
    toggleVisibility(elements.loadingIndicator, true);
    toggleVisibility(elements.searchResults, true);
    toggleVisibility(elements.articleResults, true);
    toggleVisibility(elements.collectionResults, true);
    toggleVisibility(elements.noResultsMessage, true);
  }

  function showLoadingIndicator() {
    toggleVisibility(elements.defaultMessage, true);
    toggleVisibility(elements.loadingIndicator, false);
    toggleVisibility(elements.searchResults, true);
    toggleVisibility(elements.articleResults, true);
    toggleVisibility(elements.collectionResults, true);
    toggleVisibility(elements.noResultsMessage, true);
  }

  function showSearchResults() {
    toggleVisibility(elements.defaultMessage, true);
    toggleVisibility(elements.loadingIndicator, true);
    toggleVisibility(elements.searchResults, false);
    toggleVisibility(elements.articleResults, true);
    toggleVisibility(elements.collectionResults, true);
    toggleVisibility(elements.noResultsMessage, true);
  }

  function showArticleResults() {
    toggleVisibility(elements.defaultMessage, true);
    toggleVisibility(elements.loadingIndicator, true);
    toggleVisibility(elements.searchResults, true);
    toggleVisibility(elements.articleResults, false);
    toggleVisibility(elements.collectionResults, true);
  }

  function showCollectionResults() {
    toggleVisibility(elements.defaultMessage, true);
    toggleVisibility(elements.loadingIndicator, true);
    toggleVisibility(elements.searchResults, true);
    toggleVisibility(elements.articleResults, true);
    toggleVisibility(elements.collectionResults, false);
  }

  function showNoResultsMessage() {
    toggleVisibility(elements.defaultMessage, true);
    toggleVisibility(elements.loadingIndicator, true);
    toggleVisibility(elements.searchResults, true);
    toggleVisibility(elements.articleResults, true);
    toggleVisibility(elements.collectionResults, true);
    toggleVisibility(elements.noResultsMessage, false);
    toggleVisibility(elements.searchTypeButtons, true);
  }

  elements.searchBarButton.addEventListener("click", showModal);
  elements.closeSearchBarButton.addEventListener("click", hideModal);

  elements.searchBarInput.addEventListener("input", handleSearchInput);

  elements.showProductsButton.addEventListener("click", () => {
    elements.showProductsButton.classList.add("active");
    elements.showArticlesButton.classList.remove("active");
    elements.showCollectionsButton.classList.remove("active");
    showSearchResults();
  });

  elements.showArticlesButton.addEventListener("click", () => {
    elements.showArticlesButton.classList.add("active");
    elements.showProductsButton.classList.remove("active");
    elements.showCollectionsButton.classList.remove("active");
    showArticleResults();
  });

  elements.showCollectionsButton.addEventListener("click", () => {
    elements.showCollectionsButton.classList.add("active");
    elements.showProductsButton.classList.remove("active");
    elements.showArticlesButton.classList.remove("active");
    showCollectionResults();
  });

  window.addEventListener("click", (event) => {
    if (event.target === elements.searchModal) hideModal();
  });

  window.addEventListener("keydown", (event) => {
    if (event.key === "Escape") hideModal();
  });

  showDefaultMessage();
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////// The tag search in code above fetches all products when no results were found for title and vendor ////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//// In case the tag search is causing issues, revert to code below which only searches product by title or vendor ////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// document.addEventListener("DOMContentLoaded", function () {
//   const elements = {
//     searchBarButton: document.getElementById("searchBarButton"),
//     searchModal: document.getElementById("searchModal"),
//     modalContent: document.querySelector(".nav-searchbar-modal-content"),
//     searchResults: document.getElementById("searchResults"),
//     articleResults: document.getElementById("articleResults"),
//     collectionResults: document.getElementById("collectionResults"),
//     defaultMessage: document.getElementById("defaultSearchDisplay"),
//     loadingIndicator: document.getElementById("loadingIndicator"),
//     noResultsMessage: document.getElementById("noResultsMessage"),
//     closeSearchBarButton: document.getElementById("closeSearchBarButton"),
//     searchBarInput: document.querySelector(".nav-searchbar-input"),
//     showProductsButton: document.getElementById("showProductsButton"),
//     showArticlesButton: document.getElementById("showArticlesButton"),
//     showCollectionsButton: document.getElementById("showCollectionsButton"),
//     searchTypeButtons: document.getElementById("searchTypeButtons"),
//     searchTitle: document.getElementById("searchTitle"),
//     searchTitleText: document.getElementById("searchTitleText"),
//   };

//   let debounceTimeout;
//   let focusableElementsOutsideModal = [];

//   // Function to trap focus within the modal
//   const trapFocus = (element) => {
//     const focusableElements = element.querySelectorAll(
//       'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
//     );
//     const firstFocusableElement = focusableElements[0];
//     const lastFocusableElement =
//       focusableElements[focusableElements.length - 1];

//     element.addEventListener("keydown", (e) => {
//       if (e.key === "Tab") {
//         if (e.shiftKey) {
//           // Shift + Tab: Move focus backward
//           if (document.activeElement === firstFocusableElement) {
//             e.preventDefault();
//             lastFocusableElement.focus(); // Loop back to the last element
//           }
//         } else {
//           // Tab: Move focus forward
//           if (document.activeElement === lastFocusableElement) {
//             e.preventDefault();
//             firstFocusableElement.focus(); // Loop back to the first element
//           }
//         }
//       }
//     });
//   };

//   // Function to disable focus on elements outside the modal
//   const disableFocusOutsideModal = () => {
//     focusableElementsOutsideModal = Array.from(
//       document.querySelectorAll(
//         'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
//       )
//     ).filter((el) => !elements.searchModal.contains(el));

//     focusableElementsOutsideModal.forEach((el) => {
//       el.setAttribute("data-tabindex", el.getAttribute("tabindex") || "0");
//       el.setAttribute("tabindex", "-1");
//     });
//   };

//   // Function to enable focus back on elements outside the modal
//   const enableFocusOutsideModal = () => {
//     focusableElementsOutsideModal.forEach((el) => {
//       const originalTabindex = el.getAttribute("data-tabindex");
//       if (originalTabindex === "0") {
//         el.removeAttribute("tabindex");
//       } else {
//         el.setAttribute("tabindex", originalTabindex);
//       }
//       el.removeAttribute("data-tabindex");
//     });
//   };

//   function toggleVisibility(element, hide, displayType = "block") {
//     element.style.display = hide ? "none" : displayType;
//     element.setAttribute("aria-hidden", hide ? "true" : "false");
//   }

//   function showModal() {
//     toggleVisibility(elements.searchModal, false);
//     elements.searchBarButton.setAttribute("aria-expanded", "true");
//     disableBodyScroll(); // Disable body scroll
//     disableFocusOutsideModal(); // Disable focus on elements outside the modal
//     setTimeout(() => {
//       elements.modalContent.style.right = "0";
//     }, 10);
//     if (window.innerWidth >= 800) {
//       elements.searchBarInput.focus();
//     }
//     requestAnimationFrame(() => {
//       trapFocus(elements.searchModal); // Trap focus after rendering the frame
//     });
//   }

//   function hideModal() {
//     elements.modalContent.style.right = "-100%";
//     enableBodyScroll(); // Re-enable body scroll
//     enableFocusOutsideModal(); // Enable focus back on elements outside the modal
//     setTimeout(() => {
//       toggleVisibility(elements.searchModal, true);
//       elements.searchBarButton.setAttribute("aria-expanded", "false");
//       elements.searchBarButton.focus();
//     }, 400);
//     resetState();
//   }

//   function disableBodyScroll() {
//     document.body.style.overflow = "hidden"; // Disable body scroll
//     elements.modalContent.style.overflowY = "auto"; // Ensure the modal itself can scroll
//   }

//   function enableBodyScroll() {
//     document.body.style.overflow = ""; // Re-enable body scroll
//     elements.modalContent.style.overflowY = ""; // Reset overflow on the modal
//   }

//   function resetState() {
//     elements.searchBarInput.value = "";
//     resetTabs();
//     showDefaultMessage();
//     toggleVisibility(elements.searchTypeButtons, true);
//     toggleVisibility(elements.searchTitle, true);
//   }

//   function resetTabs() {
//     elements.showProductsButton.classList.add("active");
//     elements.showArticlesButton.classList.remove("active");
//     elements.showCollectionsButton.classList.remove("active");
//   }

//   function formatPrice(price) {
//     return `€ ${parseInt(price, 10).toLocaleString("de-DE")}`;
//   }

//   function createElement(templateId, data, mappings) {
//     const template = document
//       .getElementById(templateId)
//       .content.cloneNode(true);
//     Object.entries(mappings).forEach(([selector, value]) => {
//       const element = template.querySelector(selector);
//       if (element) {
//         if (typeof value === "function") {
//           value(element, data);
//         } else {
//           element.textContent = data[value];
//         }
//       }
//     });
//     return template;
//   }

//   function damerauLevenshteinDistance(a, b) {
//     const lenA = a.length;
//     const lenB = b.length;
//     const dp = Array.from({ length: lenA + 1 }, () => Array(lenB + 1).fill(0));

//     for (let i = 0; i <= lenA; i++) dp[i][0] = i;
//     for (let j = 0; j <= lenB; j++) dp[0][j] = j;

//     for (let i = 1; i <= lenA; i++) {
//       for (let j = 1; j <= lenB; j++) {
//         const cost = a[i - 1] === b[j - 1] ? 0 : 1;
//         dp[i][j] = Math.min(
//           dp[i - 1][j] + 1,
//           dp[i][j - 1] + 1,
//           dp[i - 1][j - 1] + cost
//         );
//         if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
//           dp[i][j] = Math.min(dp[i][j], dp[i - 2][j - 2] + cost);
//         }
//       }
//     }
//     return dp[lenA][lenB];
//   }

//   function isFuzzyMatch(query, target) {
//     const lowerQuery = query.toLowerCase();
//     const lowerTarget = target.toLowerCase();
//     const maxDistance = lowerQuery.length <= 5 ? 1 : 2;

//     if (lowerTarget.includes(lowerQuery)) return true;

//     for (let i = 0; i <= lowerTarget.length - lowerQuery.length; i++) {
//       const substring = lowerTarget.substring(i, i + lowerQuery.length);
//       if (damerauLevenshteinDistance(lowerQuery, substring) <= maxDistance) {
//         return true;
//       }
//     }
//     return false;
//   }

//   function getFuzzyDistance(query, target) {
//     const lowerQuery = query.toLowerCase();
//     const lowerTarget = target.toLowerCase();

//     let minDistance = Infinity;
//     for (let i = 0; i <= lowerTarget.length - lowerQuery.length; i++) {
//       const substring = lowerTarget.substring(i, i + lowerQuery.length);
//       const distance = damerauLevenshteinDistance(lowerQuery, substring);
//       if (distance < minDistance) minDistance = distance;
//     }
//     return minDistance;
//   }

//   function matchInFields(query, item) {
//     return [item.title, item.vendor || ""].some((field) =>
//       isFuzzyMatch(query, field)
//     );
//   }

//   async function fetchData(query, type) {
//     const broadQuery = query.length > 2 ? query.slice(0, 2) : query;
//     const response = await fetch(
//       `/search/suggest.json?q=${encodeURIComponent(
//         broadQuery
//       )}&resources[type]=${type}`
//     );
//     if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
//     return response.json();
//   }

//   function processResults(items, templateId, resultsContainer, mappings) {
//     resultsContainer.innerHTML = "";
//     const fuzzyResults = items
//       .filter((item) => matchInFields(elements.searchBarInput.value, item))
//       .map((item) => ({
//         item,
//         distance: getFuzzyDistance(elements.searchBarInput.value, item.title),
//       }))
//       .sort((a, b) => a.distance - b.distance)
//       .map((result) => result.item);

//     if (fuzzyResults.length > 0) {
//       fuzzyResults.forEach((item) => {
//         const element = createElement(templateId, item, mappings);
//         resultsContainer.appendChild(element);
//       });
//     }
//   }

//   async function fetchSearchResults(query) {
//     try {
//       const data = await fetchData(query, "product");
//       processResults(
//         data.resources.results.products,
//         "productSearchResultTemplate",
//         elements.searchResults,
//         {
//           a: (el, product) => (el.href = product.url),
//           img: (el, product) => {
//             el.src = product.image;
//             el.alt = product.title;
//           },
//           h5: "title",
//           ".product-vendor": "vendor",
//           ".product-price": (el, product) =>
//             (el.textContent = formatPrice(product.price)),
//         }
//       );
//     } catch (error) {
//       handleError(error);
//     }
//   }

//   async function fetchArticleResults(query) {
//     try {
//       const data = await fetchData(query, "article");
//       processResults(
//         data.resources.results.articles,
//         "articleSearchResultTemplate",
//         elements.articleResults,
//         {
//           a: (el, article) => (el.href = article.url),
//           img: (el, article) => {
//             el.src = article.image;
//             el.alt = article.title;
//           },
//           h5: "title",
//           ".article-body": (el, article) =>
//             (el.textContent = article.body.substring(0, 100) + "..."),
//         }
//       );
//     } catch (error) {
//       handleError(error);
//     }
//   }

//   async function fetchCollectionResults(query) {
//     try {
//       const data = await fetchData(query, "collection");
//       processResults(
//         data.resources.results.collections,
//         "collectionSearchResultTemplate",
//         elements.collectionResults,
//         {
//           a: (el, collection) => (el.href = collection.url),
//           h5: "title",
//         }
//       );
//     } catch (error) {
//       handleError(error);
//     }
//   }

//   function handleError(error) {
//     console.error("Error fetching results:", error);
//     toggleVisibility(elements.noResultsMessage, false);
//     toggleVisibility(elements.defaultMessage, true);
//     toggleVisibility(elements.loadingIndicator, true);
//   }

//   function handleSearchInput() {
//     const query = elements.searchBarInput.value.trim();
//     if (!query) {
//       clearTimeout(debounceTimeout);
//       resetState();
//       return;
//     }

//     showLoadingIndicator();
//     clearTimeout(debounceTimeout);

//     debounceTimeout = setTimeout(async () => {
//       try {
//         await Promise.all([
//           fetchSearchResults(query),
//           fetchArticleResults(query),
//           fetchCollectionResults(query),
//         ]);

//         const hasProducts = elements.searchResults.innerHTML.trim().length > 0;
//         const hasArticles = elements.articleResults.innerHTML.trim().length > 0;
//         const hasCollections =
//           elements.collectionResults.innerHTML.trim().length > 0;

//         if (hasProducts + hasArticles + hasCollections > 1) {
//           toggleVisibility(elements.searchTypeButtons, false, "flex");
//           toggleVisibility(elements.searchTitle, true);
//           resetTabs();
//           toggleVisibility(elements.noResultsMessage, true);

//           elements.showProductsButton.style.display = hasProducts
//             ? "inline-block"
//             : "none";
//           elements.showArticlesButton.style.display = hasArticles
//             ? "inline-block"
//             : "none";
//           elements.showCollectionsButton.style.display = hasCollections
//             ? "inline-block"
//             : "none";

//           // Show the first type of result by default
//           if (hasProducts) {
//             elements.showProductsButton.classList.add("active");
//             showSearchResults();
//           } else if (hasArticles) {
//             elements.showArticlesButton.classList.add("active");
//             showArticleResults();
//           } else if (hasCollections) {
//             elements.showCollectionsButton.classList.add("active");
//             showCollectionResults();
//           }
//         } else if (hasProducts || hasArticles || hasCollections) {
//           toggleVisibility(elements.searchTypeButtons, true);
//           toggleVisibility(elements.searchTitle, false);
//           if (hasProducts) {
//             elements.searchTitleText.innerText =
//               elements.searchTitleText.getAttribute("data-products-title");
//             showSearchResults();
//           } else if (hasArticles) {
//             elements.searchTitleText.innerText =
//               elements.searchTitleText.getAttribute("data-articles-title");
//             showArticleResults();
//           } else if (hasCollections) {
//             elements.searchTitleText.innerText =
//               elements.searchTitleText.getAttribute("data-collections-title");
//             showCollectionResults();
//           }
//         } else {
//           toggleVisibility(elements.searchTypeButtons, true);
//           toggleVisibility(elements.searchTitle, true);
//           showNoResultsMessage();
//         }
//       } catch (error) {
//         handleError(error);
//       }
//     }, 300);
//   }

//   function showDefaultMessage() {
//     toggleVisibility(elements.defaultMessage, false);
//     toggleVisibility(elements.loadingIndicator, true);
//     toggleVisibility(elements.searchResults, true);
//     toggleVisibility(elements.articleResults, true);
//     toggleVisibility(elements.collectionResults, true);
//     toggleVisibility(elements.noResultsMessage, true);
//   }

//   function showLoadingIndicator() {
//     toggleVisibility(elements.defaultMessage, true);
//     toggleVisibility(elements.loadingIndicator, false);
//     toggleVisibility(elements.searchResults, true);
//     toggleVisibility(elements.articleResults, true);
//     toggleVisibility(elements.collectionResults, true);
//     toggleVisibility(elements.noResultsMessage, true);
//   }

//   function showSearchResults() {
//     toggleVisibility(elements.defaultMessage, true);
//     toggleVisibility(elements.loadingIndicator, true);
//     toggleVisibility(elements.searchResults, false);
//     toggleVisibility(elements.articleResults, true);
//     toggleVisibility(elements.collectionResults, true);
//     toggleVisibility(elements.noResultsMessage, true);
//   }

//   function showArticleResults() {
//     toggleVisibility(elements.defaultMessage, true);
//     toggleVisibility(elements.loadingIndicator, true);
//     toggleVisibility(elements.searchResults, true);
//     toggleVisibility(elements.articleResults, false);
//     toggleVisibility(elements.collectionResults, true);
//   }

//   function showCollectionResults() {
//     toggleVisibility(elements.defaultMessage, true);
//     toggleVisibility(elements.loadingIndicator, true);
//     toggleVisibility(elements.searchResults, true);
//     toggleVisibility(elements.articleResults, true);
//     toggleVisibility(elements.collectionResults, false);
//   }

//   function showNoResultsMessage() {
//     toggleVisibility(elements.defaultMessage, true);
//     toggleVisibility(elements.loadingIndicator, true);
//     toggleVisibility(elements.searchResults, true);
//     toggleVisibility(elements.articleResults, true);
//     toggleVisibility(elements.collectionResults, true);
//     toggleVisibility(elements.noResultsMessage, false);
//     toggleVisibility(elements.searchTypeButtons, true); // Hide buttons when no results
//   }

//   elements.searchBarButton.addEventListener("click", showModal);
//   elements.closeSearchBarButton.addEventListener("click", hideModal);
//   elements.searchBarInput.addEventListener("input", handleSearchInput);

//   elements.showProductsButton.addEventListener("click", () => {
//     elements.showProductsButton.classList.add("active");
//     elements.showArticlesButton.classList.remove("active");
//     elements.showCollectionsButton.classList.remove("active");
//     showSearchResults();
//   });

//   elements.showArticlesButton.addEventListener("click", () => {
//     elements.showArticlesButton.classList.add("active");
//     elements.showProductsButton.classList.remove("active");
//     elements.showCollectionsButton.classList.remove("active");
//     showArticleResults();
//   });

//   elements.showCollectionsButton.addEventListener("click", () => {
//     elements.showCollectionsButton.classList.add("active");
//     elements.showProductsButton.classList.remove("active");
//     elements.showArticlesButton.classList.remove("active");
//     showCollectionResults();
//   });

//   window.addEventListener("click", (event) => {
//     if (event.target === elements.searchModal) hideModal();
//   });

//   window.addEventListener("keydown", (event) => {
//     if (event.key === "Escape") hideModal();
//   });

//   showDefaultMessage();
// });

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
